import React, { useState } from 'react';
import { useFilters } from '../../contexts/FilterContext';

const PowerUserControlPanel = ({ show, onClose }) => {
  const filters = useFilters();
  const [search, setSearch] = useState('');

  if (!show) return null;

  const {
    educatedIndividualFilters, setEducatedIndividualFilters,
    eiMinWords, setEiMinWords,
    minWordCount, setMinWordCount,
    documentTypes, selectedDocTypes, setSelectedDocTypes,
    docTypeMinWords, setDocTypeMinWords,
    certificationFilters, setCertificationFilters,
    certMinWords, setCertMinWords,
    contentMinWords, setContentMinWords,
    minQualityScore, setMinQualityScore,
    exactMatch, setExactMatch,
    searchDepth, setSearchDepth,
    aggregation, setAggregation,
    selectedCategories, setSelectedCategories
  } = filters;

  const categories = filters.categories || [];

  const MiniToggle = ({ checked, onChange, label, color = '#38bdf8' }) => (
    <label style={{ display: 'flex', alignItems: 'center', gap: 4, cursor: 'pointer', padding: '1px 3px', fontSize: '0.56rem' }}>
      <div onClick={(e) => { e.preventDefault(); onChange(!checked); }} style={{
        width: 22, height: 12, borderRadius: 6, position: 'relative', cursor: 'pointer',
        background: checked ? color : 'rgba(255,255,255,0.1)', border: `1px solid ${checked ? color : 'rgba(255,255,255,0.15)'}`, transition: 'all 0.15s'
      }}>
        <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#fff', position: 'absolute', top: 1, left: checked ? 11 : 2, transition: 'left 0.15s' }} />
      </div>
      <span style={{ color: checked ? color : '#555', fontWeight: checked ? 600 : 400, whiteSpace: 'nowrap' }}>{label}</span>
    </label>
  );

  const MiniInput = ({ value, onChange, width = 38, color = '#38bdf8' }) => (
    <input type="number" value={value} min={0} max={50000}
      onChange={e => onChange(parseInt(e.target.value) || 0)}
      onFocus={e => e.stopPropagation()}
      onTouchStart={e => e.stopPropagation()}
      onMouseDown={e => e.stopPropagation()}
      onClick={e => e.stopPropagation()}
      style={{ width, background: 'rgba(255, 255, 255, 0.85)', border: `1px solid ${color}33`, color, padding: '1px 3px', borderRadius: 3, fontSize: '0.5rem', textAlign: 'right', fontFamily: 'monospace' }} />
  );

  const matchesSearch = (label) => !search || label.toLowerCase().includes(search.toLowerCase());

  const eiTopics = ['science', 'engineering', 'construction', 'culinary', 'trades', 'mathematics', 'technology'];
  const certItems = [
    { key: 'pearsonvue', label: 'PearsonVUE', color: '#FDE047' },
    { key: 'government', label: 'Government', color: '#ef4444' },
    { key: 'advancedDegree', label: 'Adv. Degree', color: '#3b82f6' }
  ];

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.92)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      onClick={onClose} data-testid="power-user-panel-overlay">
      <div onClick={e => e.stopPropagation()} style={{
        width: '90vw', maxWidth: 1100, maxHeight: '90vh', background: '#08080f',
        border: '1px solid rgba(253, 230, 138,0.2)', borderRadius: 8,
        fontFamily: '"SF Mono", "Fira Code", "Consolas", monospace',
        display: 'flex', flexDirection: 'column', overflow: 'hidden',
        boxShadow: '0 0 80px rgba(253, 230, 138,0.06), 0 0 2px rgba(253, 230, 138,0.3)'
      }} data-testid="power-user-panel">
        
        {/* Header */}
        <div style={{ padding: '6px 12px', background: 'rgba(253, 230, 138,0.04)', borderBottom: '1px solid rgba(253, 230, 138,0.1)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ color: '#38bdf8', fontSize: '0.65rem', fontWeight: 700, letterSpacing: 2 }}>PROGRAMMER MODE</span>
            <span style={{ color: '#333', fontSize: '0.5rem' }}>ALL CONTROLS &middot; INSTANT APPLY</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <input type="text" value={search} onChange={e => setSearch(e.target.value)}
              placeholder="Filter controls..." data-testid="power-user-search"
              style={{ width: 160, background: 'rgba(253, 230, 138,0.06)', border: '1px solid rgba(253, 230, 138,0.15)', color: '#334155', padding: '3px 8px', borderRadius: 4, fontSize: '0.52rem', fontFamily: 'inherit' }} />
            <button onClick={() => {
              setSelectedDocTypes(documentTypes.map(d => d.id));
              setEducatedIndividualFilters(p => { const n = {}; Object.keys(p).forEach(k => n[k] = true); return n; });
            }} style={{ background: 'rgba(16,185,129,0.12)', border: '1px solid rgba(16,185,129,0.25)', color: '#10b981', padding: '2px 6px', borderRadius: 3, fontSize: '0.48rem', cursor: 'pointer', fontFamily: 'inherit' }}
              data-testid="power-user-all-on">ALL ON</button>
            <button onClick={() => {
              setSelectedDocTypes([]);
              setEducatedIndividualFilters(p => { const n = {}; Object.keys(p).forEach(k => n[k] = false); return n; });
              setCertificationFilters({ pearsonvue: false, government: false, advancedDegree: false });
            }} style={{ background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.25)', color: '#ef4444', padding: '2px 6px', borderRadius: 3, fontSize: '0.48rem', cursor: 'pointer', fontFamily: 'inherit' }}
              data-testid="power-user-all-off">ALL OFF</button>
            <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#555', fontSize: '1rem', cursor: 'pointer', padding: '0 4px', fontFamily: 'inherit' }}
              data-testid="power-user-close">&times;</button>
          </div>
        </div>

        {/* Body - Dense Grid */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '8px 12px', display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8 }}>
          
          {/* Section 1: EI Topics */}
          <div style={{ background: 'rgba(253, 230, 138,0.03)', borderRadius: 6, padding: 8, border: '1px solid rgba(253, 230, 138,0.08)' }}>
            <div style={{ fontSize: '0.5rem', color: '#38bdf8', fontWeight: 700, marginBottom: 6, letterSpacing: 1, borderBottom: '1px solid rgba(253, 230, 138,0.1)', paddingBottom: 4 }}>
              EI TOPICS
            </div>
            {eiTopics.filter(t => matchesSearch(t)).map(topic => (
              <div key={topic} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '2px 0', borderBottom: '1px solid rgba(253, 230, 138,0.04)' }}>
                <MiniToggle checked={educatedIndividualFilters[topic]} color="#38bdf8"
                  onChange={() => setEducatedIndividualFilters(p => ({ ...p, [topic]: !p[topic] }))}
                  label={topic.charAt(0).toUpperCase() + topic.slice(1)} />
                <MiniInput value={eiMinWords[topic] || 0} color="#38bdf8"
                  onChange={v => setEiMinWords(p => ({ ...p, [topic]: v }))} />
              </div>
            ))}
            {matchesSearch('visuals') && (
              <MiniToggle checked={educatedIndividualFilters.favor_visuals} color="#22d3ee"
                onChange={() => setEducatedIndividualFilters(p => ({ ...p, favor_visuals: !p.favor_visuals }))}
                label="Favor Visuals" />
            )}
            {matchesSearch('pictures') && (
              <MiniToggle checked={educatedIndividualFilters.favor_pictures} color="#38bdf8"
                onChange={() => setEducatedIndividualFilters(p => ({ ...p, favor_pictures: !p.favor_pictures }))}
                label="Favor Pictures" />
            )}
            {matchesSearch('word') && (
              <div style={{ marginTop: 4, display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderTop: '1px solid rgba(253, 230, 138,0.1)', paddingTop: 4 }}>
                <span style={{ color: '#555', fontSize: '0.48rem' }}>GLOBAL MIN</span>
                <MiniInput value={minWordCount} color="#38bdf8" onChange={setMinWordCount} width={44} />
              </div>
            )}
          </div>

          {/* Section 2: Document Types */}
          <div style={{ background: 'rgba(253, 224, 71,0.03)', borderRadius: 6, padding: 8, border: '1px solid rgba(253, 224, 71,0.08)' }}>
            <div style={{ fontSize: '0.5rem', color: '#FDE047', fontWeight: 700, marginBottom: 6, letterSpacing: 1, borderBottom: '1px solid rgba(253, 224, 71,0.1)', paddingBottom: 4 }}>
              DOC TYPES ({selectedDocTypes.length}/{documentTypes.length})
            </div>
            <div style={{ display: 'flex', gap: 3, marginBottom: 4 }}>
              <button onClick={() => setSelectedDocTypes(documentTypes.map(d => d.id))}
                style={{ background: 'rgba(16,185,129,0.12)', border: '1px solid rgba(16,185,129,0.2)', color: '#10b981', padding: '1px 5px', borderRadius: 3, fontSize: '0.44rem', cursor: 'pointer' }}>ALL</button>
              <button onClick={() => setSelectedDocTypes([])}
                style={{ background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.2)', color: '#ef4444', padding: '1px 5px', borderRadius: 3, fontSize: '0.44rem', cursor: 'pointer' }}>NONE</button>
            </div>
            <div style={{ maxHeight: 220, overflowY: 'auto' }}>
              {documentTypes.filter(dt => matchesSearch(dt.name)).map(dt => (
                <div key={dt.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '2px 0', borderBottom: '1px solid rgba(253, 224, 71,0.04)' }}>
                  <MiniToggle checked={selectedDocTypes.includes(dt.id)} color={dt.color || '#FDE047'}
                    onChange={() => setSelectedDocTypes(p => p.includes(dt.id) ? p.filter(d => d !== dt.id) : [...p, dt.id])}
                    label={dt.name} />
                  <MiniInput value={docTypeMinWords[dt.id] || 0} color="#FDE047"
                    onChange={v => setDocTypeMinWords(p => ({ ...p, [dt.id]: v }))} />
                </div>
              ))}
            </div>
          </div>

          {/* Section 3: Certifications + Content Prefs */}
          <div style={{ background: 'rgba(239,68,68,0.03)', borderRadius: 6, padding: 8, border: '1px solid rgba(239,68,68,0.08)' }}>
            <div style={{ fontSize: '0.5rem', color: '#ef4444', fontWeight: 700, marginBottom: 6, letterSpacing: 1, borderBottom: '1px solid rgba(239,68,68,0.1)', paddingBottom: 4 }}>
              CERTIFICATIONS
            </div>
            {certItems.filter(f => matchesSearch(f.label)).map(f => (
              <div key={f.key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '2px 0', borderBottom: '1px solid rgba(239,68,68,0.04)' }}>
                <MiniToggle checked={certificationFilters[f.key]} color={f.color}
                  onChange={() => setCertificationFilters(p => ({ ...p, [f.key]: !p[f.key] }))}
                  label={f.label} />
                <MiniInput value={certMinWords[f.key] || 0} color={f.color}
                  onChange={v => setCertMinWords(p => ({ ...p, [f.key]: v }))} />
              </div>
            ))}
            
            <div style={{ fontSize: '0.5rem', color: '#10b981', fontWeight: 700, marginTop: 8, marginBottom: 6, letterSpacing: 1, borderBottom: '1px solid rgba(16,185,129,0.1)', paddingBottom: 4 }}>
              CONTENT PREFS
            </div>
            {Object.keys(contentMinWords).filter(k => matchesSearch(k)).map(ct => (
              <div key={ct} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '2px 0', borderBottom: '1px solid rgba(16,185,129,0.04)' }}>
                <span style={{ color: '#71717a', fontSize: '0.52rem' }}>{ct.charAt(0).toUpperCase() + ct.slice(1)}</span>
                <MiniInput value={contentMinWords[ct] || 0} color="#10b981"
                  onChange={v => setContentMinWords(p => ({ ...p, [ct]: v }))} />
              </div>
            ))}
          </div>

          {/* Section 4: Search Controls + Categories */}
          <div style={{ background: 'rgba(245,158,11,0.03)', borderRadius: 6, padding: 8, border: '1px solid rgba(245,158,11,0.08)' }}>
            <div style={{ fontSize: '0.5rem', color: '#f59e0b', fontWeight: 700, marginBottom: 6, letterSpacing: 1, borderBottom: '1px solid rgba(245,158,11,0.1)', paddingBottom: 4 }}>
              SEARCH CONTROLS
            </div>
            
            {matchesSearch('exact') && (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '3px 0', borderBottom: '1px solid rgba(245,158,11,0.04)' }}>
                <span style={{ color: '#71717a', fontSize: '0.52rem' }}>Exact Match</span>
                <MiniToggle checked={exactMatch} color="#f59e0b" onChange={() => setExactMatch(!exactMatch)} label={exactMatch ? 'ON' : 'OFF'} />
              </div>
            )}
            
            {matchesSearch('depth') && (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '3px 0', borderBottom: '1px solid rgba(245,158,11,0.04)' }}>
                <span style={{ color: '#71717a', fontSize: '0.52rem' }}>Depth</span>
                <select value={searchDepth} onChange={e => setSearchDepth(parseInt(e.target.value))}
                  style={{ background: 'rgba(245,158,11,0.06)', border: '1px solid rgba(245,158,11,0.15)', color: '#f59e0b', padding: '1px 4px', borderRadius: 3, fontSize: '0.48rem', fontFamily: 'inherit' }}>
                  {[10, 20, 30, 50, 100].map(v => <option key={v} value={v}>{v}</option>)}
                </select>
              </div>
            )}
            
            {matchesSearch('logic') && (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '3px 0', borderBottom: '1px solid rgba(245,158,11,0.04)' }}>
                <span style={{ color: '#71717a', fontSize: '0.52rem' }}>Logic</span>
                <div style={{ display: 'flex', gap: 3 }}>
                  {['or', 'and', 'and_or'].map(v => (
                    <button key={v} onClick={() => setAggregation(v)}
                      style={{
                        background: aggregation === v ? 'rgba(245,158,11,0.15)' : 'transparent',
                        border: aggregation === v ? '1px solid rgba(245,158,11,0.3)' : '1px solid rgba(255,255,255,0.06)',
                        color: aggregation === v ? '#f59e0b' : '#444',
                        padding: '1px 4px', borderRadius: 3, fontSize: '0.44rem', cursor: 'pointer', fontWeight: aggregation === v ? 700 : 400, fontFamily: 'inherit'
                      }}>{v.toUpperCase()}</button>
                  ))}
                </div>
              </div>
            )}
            
            {matchesSearch('quality') && (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '3px 0', borderBottom: '1px solid rgba(245,158,11,0.04)' }}>
                <span style={{ color: '#71717a', fontSize: '0.52rem' }}>Quality</span>
                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                  <input type="range" min={0} max={100} step={5} value={minQualityScore}
                    onChange={e => setMinQualityScore(parseInt(e.target.value))}
                    style={{ width: 60, height: 6, accentColor: '#f59e0b' }} />
                  <span style={{ color: '#f59e0b', fontSize: '0.48rem', width: 18, textAlign: 'right' }}>{minQualityScore}</span>
                </div>
              </div>
            )}

            {/* Categories mini-list */}
            {matchesSearch('categor') && categories.length > 0 && (
              <>
                <div style={{ fontSize: '0.5rem', color: '#3b82f6', fontWeight: 700, marginTop: 8, marginBottom: 4, letterSpacing: 1, borderBottom: '1px solid rgba(245, 158, 11,0.1)', paddingBottom: 4 }}>
                  CATEGORIES ({selectedCategories?.length || 0}/{categories.length})
                </div>
                <div style={{ display: 'flex', gap: 3, marginBottom: 3 }}>
                  <button onClick={() => setSelectedCategories(categories.map(c => c.id))}
                    style={{ background: 'rgba(16,185,129,0.12)', border: '1px solid rgba(16,185,129,0.2)', color: '#10b981', padding: '1px 5px', borderRadius: 3, fontSize: '0.44rem', cursor: 'pointer' }}>ALL</button>
                  <button onClick={() => setSelectedCategories([])}
                    style={{ background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.2)', color: '#ef4444', padding: '1px 5px', borderRadius: 3, fontSize: '0.44rem', cursor: 'pointer' }}>NONE</button>
                </div>
                <div style={{ maxHeight: 120, overflowY: 'auto' }}>
                  {categories.map(cat => (
                    <MiniToggle key={cat.id} checked={selectedCategories?.includes(cat.id)} color="#3b82f6"
                      onChange={() => setSelectedCategories(p => p?.includes(cat.id) ? p.filter(id => id !== cat.id) : [...(p || []), cat.id])}
                      label={`${cat.name} (${cat.url_count || 0})`} />
                  ))}
                </div>
              </>
            )}
          </div>
        </div>

        {/* Footer */}
        <div style={{ padding: '4px 12px', borderTop: '1px solid rgba(253, 230, 138,0.08)', background: 'rgba(253, 230, 138,0.02)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
          <span style={{ color: '#333', fontSize: '0.46rem' }}>Changes apply instantly &middot; Press ESC or click outside to close</span>
          <span style={{ color: '#38bdf8', fontSize: '0.46rem' }}>PROGRAMMER MODE v1.0</span>
        </div>
      </div>
    </div>
  );
};

export default PowerUserControlPanel;
